import React from "react";

const richTextEditorCentreAlignLink = (
  matchValue: string,
  { renderToString }: { renderToString: NonNullable<typeof globalThis.__renderToString> },
) => {
  const linkAttributes = {
    href: matchValue
      .split("(")
      .pop()
      ?.split(/(\)|\s)/)[0],
    text: matchValue.split("[")[1].split("]")[0],
    title: matchValue.match(/"(.)*"\)/) ? matchValue.split(' "').pop()?.split('"')[0] : undefined,
  };

  return renderToString(
    <a href={linkAttributes.href} title={linkAttributes.title}>
      {linkAttributes.text}
    </a>,
  );
};

export default richTextEditorCentreAlignLink;
